/**
 * Rozkład dopłaty na raty — wybór operatora w kroku W2.
 *
 * **To nie jest kontrakt backendu.** Backend zna jeden rozkład
 * (`SchedulePlan`): proporcjonalnie po ratach nieopłaconych, plus linia
 * resztkowa na to, czego raty nie wchłonęły. `resolve` nie przyjmuje wyboru
 * wariantu i nie będzie — dwa pozostałe zostają na ekranie jako zapowiedź.
 */
export enum SettlementDistribution {
  /** Całość na najbliższą niezapłaconą ratę. */
  NEAREST = 'NEAREST',
  /** Proporcjonalnie po ratach nieopłaconych — jedyny, który backend umie. */
  SPREAD = 'SPREAD',
  /** Osobna pozycja z własnym terminem. */
  SEPARATE = 'SEPARATE',
}
